module.exports = __webpack_public_path__ + "media/images/rearrange-hover-6f5f1347905ca9b5e42fb667e475c124.svg";